import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0008',
    ecrans: ['00-2']
});
